<template>
  <div>
    <div class="top_bar">
      <div class="t_inner">
        <h3>{{ $t("nav.projects") }}</h3>
        <div class="slick-nav">
          <button v-on:click="prev()" class="slick-arrow prev"></button>
          <button v-on:click="next()" class="slick-arrow next"></button>
        </div>
      </div>
    </div>
    <Slick 
      ref="slick" 
      class="row as-main-carousel" 
      :options="slickOptions" 
      v-if="getProjects.length > 0"
    >
      <div v-for="item in getProjects" :key="item.id">
        <Item :item="item"></Item>
      </div>
    </Slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Item from "@/components/Project";
export default {
  computed: {
    getProjects() {
      return this.$store.state.GlobalData.projects;
    },
  },
  data() {
    return {
      slickOptions: {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        vertical: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrow: false,
            },
          },
          {
            breakpoint: 951,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrow: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrow: false,
            },
          },
        ],
      },
      locale: this.$route.params.locale,
    };
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    },
  },
  components: {
    Slick,
    Item,
  },
};
</script>

<style>
.top_bar .t_inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex: 0 100%;
}

.slick-nav {
  width: 85px;
}

.slick-arrow {
  position: relative;
  display: inline-block;
  background-color: #d24e1a;
  width: 30px;
  height: 30px;
  border-radius: 2px;
  cursor: pointer;
  border: 0;
  margin-left: 5px;
}

.slick-nav .next:after {
  border-left-color: transparent;
  border-right-color: #fff;
  left: auto;
  right: 13px;
  content: "";
  position: absolute;
  top: 11px;
  left: 13px;
  border: 5px solid transparent;
  border-left-color: #fff;
}

.slick-nav .prev:after {
  content: "";
  position: absolute;
  top: 11px;
  left: 7px;
  border: 5px solid transparent;
  border-right-color: #fff;
}
</style>
